/* ==========================================================================
   Homellence – gemeinsame Oberflächen-Bausteine
   Vanilla JS, Web Components im Stil von Dawn. Kein jQuery, keine Bibliothek.
   ========================================================================== */
(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function focusable(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  var openDrawers = 0;

  function lockScroll() {
    openDrawers += 1;
    document.body.classList.add('hl-scroll-locked');
  }

  function unlockScroll() {
    openDrawers = Math.max(0, openDrawers - 1);
    if (openDrawers === 0) document.body.classList.remove('hl-scroll-locked');
  }

  /* ------------------------------------------------------------------
     <hl-drawer>  –  Schublade (Menü, Warenkorb, Schnellansicht)
     Öffnen:  document.querySelector('#id').open()  oder ein Element mit
              data-hl-drawer-open="#id"
     ------------------------------------------------------------------ */
  class HlDrawer extends HTMLElement {
    constructor() {
      super();
      this._onKeydown = this._onKeydown.bind(this);
      this.close = this.close.bind(this);
    }

    connectedCallback() {
      var self = this;
      this.addEventListener('click', function (event) {
        if (event.target.closest('[data-hl-drawer-close]')) {
          event.preventDefault();
          self.close();
        }
      });
    }

    open(trigger) {
      if (this.hasAttribute('open')) return;
      this._trigger = trigger || document.activeElement;
      this.setAttribute('open', '');
      lockScroll();
      document.addEventListener('keydown', this._onKeydown);
      var self = this;
      // Ein Frame warten, damit der Übergang läuft und das Ziel sichtbar ist.
      requestAnimationFrame(function () {
        var target =
          self.querySelector('[autofocus]') ||
          self.querySelector('[data-hl-drawer-close]') ||
          focusable(self)[0];
        if (target) target.focus();
      });
      this.dispatchEvent(new CustomEvent('hl:drawer:open', { bubbles: true }));
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      unlockScroll();
      document.removeEventListener('keydown', this._onKeydown);
      if (this._trigger && document.contains(this._trigger)) this._trigger.focus();
      this.dispatchEvent(new CustomEvent('hl:drawer:close', { bubbles: true }));
    }

    _onKeydown(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusable(this);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('hl-drawer')) customElements.define('hl-drawer', HlDrawer);

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-hl-drawer-open]');
    if (!opener) return;
    var drawer = document.querySelector(opener.getAttribute('data-hl-drawer-open'));
    if (!drawer || typeof drawer.open !== 'function') return;
    event.preventDefault();
    drawer.open(opener);
  });

  /* ------------------------------------------------------------------
     <hl-menu>  –  Navigation mit einer zweiten Ebene (Desktop)
     ------------------------------------------------------------------ */
  /* Z1 (Runde 30) - Die Klappe war nicht zu treffen.

     Kristins Befund: "Die Unterpunkte ... sind zum Teil schwer aufzurufen,
     da sie immer verschwinden." Zwei Ursachen, beide behoben:

     1. **Die Luecke.** Zwischen der Unterkante des Hauptpunkts und der
        Oberkante der Klappe lagen 8 px, die zu keinem von beiden gehoerten.
        Der Zeiger verliess damit auf dem Weg nach unten den Menuepunkt, und
        `mouseleave` schloss sofort. Geschlossen wird die Luecke im
        Stylesheet durch eine unsichtbare Bruecke an der Klappe - sie ist
        Teil des Menuepunkts, also bleibt der Zeiger drin.

     2. **Das Schliessen ohne Verzoegerung.** Ein kurzes Zucken der Maus
        reichte. Jetzt wartet das Schliessen 250 ms; kommt der Zeiger in
        dieser Zeit zurueck, passiert nichts. Geoeffnet wird weiterhin
        sofort - eine Verzoegerung beim Oeffnen fuehlt sich traege an.

     Dazu neu: Ein **Klick** auf den Hauptpunkt heftet die Klappe fest. Sie
     bleibt dann offen, bis jemand woanders hinklickt oder Esc drueckt -
     auch wenn der Zeiger sie verlaesst. Wer nicht gern mit der Maus zielt,
     kommt so ebenfalls hinein.

     Die Tastaturbedienung aus Runde 28 bleibt unveraendert. */
  var SCHLIESS_VERZOEGERUNG = 250;

  class HlMenu extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-hl-submenu-toggle]'));
      this.timer = null;
      this.pinned = null;

      this.items.forEach(function (button) {
        var panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        var item = button.closest('.hl-header__nav-item');

        button.addEventListener('click', function (event) {
          event.preventDefault();
          var offen = button.getAttribute('aria-expanded') === 'true';
          if (offen && self.pinned === button) {
            self.pinned = null;
            self.sofortSchliessen(button, panel);
          } else {
            self.pinned = button;
            self.sofortOeffnen(button, panel);
          }
        });

        item.addEventListener('mouseenter', function () {
          self.sofortOeffnen(button, panel);
        });
        item.addEventListener('mouseleave', function () {
          self.spaeterSchliessen(button, panel);
        });
        item.addEventListener('focusout', function (event) {
          if (!item.contains(event.relatedTarget)) self.spaeterSchliessen(button, panel);
        });
      });

      this.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        var open = self.querySelector('[data-hl-submenu-toggle][aria-expanded="true"]');
        if (!open) return;
        self.pinned = null;
        self.sofortSchliessen(open, document.getElementById(open.getAttribute('aria-controls')));
        open.focus();
      });

      /* Ein Klick irgendwo sonst loest die Heftung und schliesst. */
      this.onAussenklick = function (event) {
        if (self.contains(event.target)) return;
        var open = self.querySelector('[data-hl-submenu-toggle][aria-expanded="true"]');
        if (!open) return;
        self.pinned = null;
        self.sofortSchliessen(open, document.getElementById(open.getAttribute('aria-controls')));
      };
      document.addEventListener('click', this.onAussenklick);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      document.removeEventListener('click', this.onAussenklick);
    }

    /* Immer nur eine Klappe offen - sonst stehen zwei uebereinander,
       sobald jemand am Menue entlangfaehrt. */
    sofortOeffnen(button, panel) {
      window.clearTimeout(this.timer);
      var self = this;
      this.items.forEach(function (other) {
        if (other === button) return;
        if (self.pinned === other) return;
        var p = document.getElementById(other.getAttribute('aria-controls'));
        if (p) self.toggle(other, p, false);
      });
      this.toggle(button, panel, true);
    }

    spaeterSchliessen(button, panel) {
      if (this.pinned === button) return;
      window.clearTimeout(this.timer);
      var self = this;
      this.timer = window.setTimeout(function () {
        self.toggle(button, panel, false);
      }, SCHLIESS_VERZOEGERUNG);
    }

    sofortSchliessen(button, panel) {
      window.clearTimeout(this.timer);
      this.toggle(button, panel, false);
    }

    toggle(button, panel, show) {
      button.setAttribute('aria-expanded', show ? 'true' : 'false');
      panel.hidden = !show;
    }
  }

  if (!customElements.get('hl-menu')) customElements.define('hl-menu', HlMenu);

  /* ------------------------------------------------------------------
     [data-hl-toggle]  –  einfaches Auf-/Zuklappen (Suchfeld)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hl-toggle]');
    if (!button) return;
    var panel = document.querySelector(button.getAttribute('data-hl-toggle'));
    if (!panel) return;
    event.preventDefault();
    var show = panel.hidden;
    panel.hidden = !show;
    button.setAttribute('aria-expanded', show ? 'true' : 'false');
    if (show) {
      var field = panel.querySelector('input, select, textarea, a, button');
      if (field) field.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('[data-hl-toggle][aria-expanded="true"]');
    if (!open) return;
    var panel = document.querySelector(open.getAttribute('data-hl-toggle'));
    if (!panel) return;
    panel.hidden = true;
    open.setAttribute('aria-expanded', 'false');
    open.focus();
  });

  /* ------------------------------------------------------------------
     N1 (Runde 45)  -  Land und Sprache: zwei Bequemlichkeiten

     Die Klappe ist ein `details`. Sie klappt vom Browser aus auf und zu,
     hoert auf Leertaste und Eingabetaste und meldet ihren Zustand selbst -
     **ohne dieses Skript**. Hier kommen nur zwei Dinge dazu, die `details`
     von sich aus nicht kann: Schliessen bei Escape und Schliessen bei
     einem Klick daneben.

     Faellt das Skript aus, bleibt die Auswahl vollstaendig bedienbar; sie
     schliesst dann durch einen zweiten Klick auf den Ausloeser. Das ist
     wichtig, weil an dieser Auswahl der Weg zur Montageseite haengt.
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var offen = document.querySelectorAll('[data-hl-loc][open]');
    for (var i = 0; i < offen.length; i++) {
      if (!offen[i].contains(event.target)) offen[i].removeAttribute('open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var loc = document.querySelector('[data-hl-loc][open]');
    if (!loc) return;
    loc.removeAttribute('open');
    var ausloeser = loc.querySelector('summary');
    if (ausloeser) ausloeser.focus();
  });

  /* ------------------------------------------------------------------
     Warenkorb-Hilfen: Zähler aktualisieren, Toast anzeigen
     ------------------------------------------------------------------ */
  var HL = (window.HL = window.HL || {});

  HL.updateCartCount = function (count) {
    document.querySelectorAll('[data-hl-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  };

  /* Die Kopfzeile serverseitig neu rendern, damit Zähler und
     Vorlesetext in der richtigen Sprache stehen. */
  HL.refreshHeaderCart = function (html) {
    var fresh = new DOMParser().parseFromString(html, 'text/html');
    var source = fresh.querySelector('[data-hl-cart-link]');
    var target = document.querySelector('[data-hl-cart-link]');
    if (source && target) target.innerHTML = source.innerHTML;
  };

  HL.toast = function (message) {
    var toast = document.querySelector('[data-hl-toast]');
    if (!toast) return;
    var text = toast.querySelector('[data-hl-toast-text]');
    if (message && text) text.textContent = message;
    toast.hidden = false;
    // Neu starten, falls der Toast schon sichtbar war.
    toast.classList.remove('is-visible');
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    clearTimeout(HL._toastTimer);
    HL._toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.hidden = true;
      }, 450);
    }, 2600);
  };

  /* Warenkorb- und Kopfzeilen-Abschnitte nach einer Änderung austauschen.
     Die Antwort von /cart/add.js bzw. /cart/change.js liefert sie mit. */
  HL.applyCartSections = function (sections) {
    if (!sections) return;
    var parser = new DOMParser();

    if (sections['hl-cart-drawer']) {
      var drawerHtml = parser.parseFromString(sections['hl-cart-drawer'], 'text/html');
      var freshBody = drawerHtml.querySelector('[data-hl-cart-body]');
      var currentBody = document.querySelector('[data-hl-cart-body]');
      if (freshBody && currentBody) currentBody.innerHTML = freshBody.innerHTML;
    }

    if (sections['hl-header']) HL.refreshHeaderCart(sections['hl-header']);
  };

  /* ------------------------------------------------------------------
     Ankuendigungsleiste: laufen nur, wenn es etwas zu laufen gibt

     Passen alle Ankuendigungen nebeneinander auf den Bildschirm, steht die
     Leiste still und die Kopie bleibt ausgeblendet - sonst stuenden die
     Texte sichtbar doppelt nebeneinander.
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     D16 · Laufband anhalten und fortsetzen

     Wer keine „reduzierte Bewegung" eingestellt hat, konnte das Band bisher
     gar nicht anhalten. Der Knopf erscheint nur, wenn das Band wirklich
     laeuft - passt der Text in die Breite, gibt es nichts anzuhalten. Der
     Zustand haelt sich ueber `sessionStorage`, gilt also fuer den Besuch.
     `prefers-reduced-motion` bleibt unberuehrt: Dort laeuft nichts.
     ------------------------------------------------------------------ */
  var MARQUEE_KEY = 'hl-marquee-paused';

  function marqueeStored() {
    try {
      return sessionStorage.getItem(MARQUEE_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function marqueeStore(paused) {
    try {
      sessionStorage.setItem(MARQUEE_KEY, paused ? '1' : '0');
    } catch (error) {
      /* Privater Modus: dann gilt der Zustand nur fuer diese Seite. */
    }
  }

  function setMarqueeState(bar, button, paused) {
    bar.classList.toggle('is-paused', paused);
    button.setAttribute('aria-pressed', paused ? 'true' : 'false');
    var label = button.getAttribute(paused ? 'data-label-play' : 'data-label-pause');
    if (label) button.setAttribute('aria-label', label);
  }

  function syncMarqueeButton(bar) {
    var button = bar.querySelector('[data-hl-marquee-toggle]');
    if (!button) return;

    var running = bar.classList.contains('is-running');
    button.hidden = !running;
    if (!running) {
      bar.classList.remove('is-paused');
      return;
    }

    setMarqueeState(bar, button, marqueeStored());

    if (button.dataset.hlReady === '1') return;
    button.dataset.hlReady = '1';
    button.addEventListener('click', function () {
      var next = !bar.classList.contains('is-paused');
      setMarqueeState(bar, button, next);
      marqueeStore(next);
    });
  }

  function setUpMarquee(bar) {
    var tracks = bar.querySelectorAll('.hl-announcement__track');
    if (tracks.length < 2) return;

    var single = tracks[0];
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function measure() {
      if (reduce.matches) {
        bar.classList.remove('is-running');
        return;
      }
      /* Die Kopie ist ausgeblendet, solange nicht gelaufen wird - die
         gemessene Breite ist also die einer einzelnen Spur. */
      var needed = single.scrollWidth;
      var available = bar.clientWidth;
      bar.classList.toggle('is-running', needed > available + 1);
      /* D16 · Der Pausenknopf gehoert an denselben Zustand: Passt das Band
         in die Breite, laeuft nichts - dann gibt es auch nichts anzuhalten.
         Wird das Fenster schmaler, faengt es an zu laufen und der Knopf
         muss erscheinen. */
      syncMarqueeButton(bar);
    }

    measure();

    var timer = 0;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(measure, 150);
    });

    if (reduce.addEventListener) reduce.addEventListener('change', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  function initMarquees() {
    Array.prototype.forEach.call(document.querySelectorAll('.hl-announcement--marquee'), setUpMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquees);
  } else {
    initMarquees();
  }

  document.addEventListener('shopify:section:load', initMarquees);

  /* ------------------------------------------------------------------
     <hl-bundle>  -  Variantenwahl im Set-Band

     Das Set hat zwei Optionen zum selben Preis. Die Auswahl schickt den
     Warenkorb-Knopf auf die passende Variante, statt stur die erste zu
     nehmen. Ohne JavaScript bleibt die vorgewaehlte Variante im
     versteckten Feld stehen - der Knopf funktioniert also weiterhin.
     ------------------------------------------------------------------ */
  class HlBundle extends HTMLElement {
    connectedCallback() {
      var dataNode = this.querySelector('[data-hl-bundle-variants]');
      this.idInput = this.querySelector('[data-hl-bundle-id]');
      this.button = this.querySelector('[data-hl-bundle-button]');
      if (!dataNode || !this.idInput) return;

      try {
        this.variants = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      // Die beiden Bildrahmen liegen in der ersten Spalte, also ausserhalb
      // dieses Elements. Deshalb wird von der Section aus gesucht.
      var root = this.closest('.hl-bundle') || document;
      this.frames = Array.prototype.slice.call(root.querySelectorAll('[data-hl-bundle-frame]'));
      var mapNode = this.querySelector('[data-hl-bundle-media-map]');
      this.mediaMap = null;
      if (mapNode) {
        try {
          this.mediaMap = JSON.parse(mapNode.textContent);
        } catch (error) {
          this.mediaMap = null;
        }
      }

      var self = this;
      this.inputs = Array.prototype.slice.call(this.querySelectorAll('[data-hl-bundle-input]'));
      this.inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          self.update();
        });
      });
    }

    /* Bilder der gewaehlten Kombination zeigen.
       Steht zu einem Rahmen nichts in der Tabelle, bleibt sein Bild stehen -
       ein leerer Rahmen darf nie entstehen. */
    showMedia(variantId) {
      if (!this.mediaMap || !this.frames || !this.frames.length) return;
      var pair = this.mediaMap[String(variantId)];
      if (!pair) return;

      this.frames.forEach(function (frame) {
        var slot = parseInt(frame.getAttribute('data-hl-bundle-frame'), 10);
        var wanted = pair[slot];
        if (wanted === null || wanted === undefined) return;

        var next = frame.querySelector('[data-hl-bundle-image="' + wanted + '"]');
        if (!next) return;

        Array.prototype.slice.call(frame.querySelectorAll('img')).forEach(function (img) {
          img.hidden = img !== next;
        });
      });
    }

    selectedValues() {
      return Array.prototype.slice
        .call(this.querySelectorAll('[data-hl-bundle-group]'))
        .map(function (group) {
          var checked = group.querySelector('[data-hl-bundle-input]:checked');
          return checked ? checked.value : null;
        });
    }

    update() {
      var values = this.selectedValues();
      var match = null;

      for (var i = 0; i < this.variants.length; i += 1) {
        var variant = this.variants[i];
        var fits = true;
        for (var j = 0; j < values.length; j += 1) {
          if (values[j] !== null && variant.options[j] !== values[j]) {
            fits = false;
            break;
          }
        }
        if (fits) {
          match = variant;
          break;
        }
      }

      if (!match) return;

      this.idInput.value = match.id;
      this.showMedia(match.id);

      if (this.button) {
        this.button.disabled = !match.available;
        var label = match.available
          ? this.button.getAttribute('data-label-available')
          : this.button.getAttribute('data-label-sold-out');
        if (label) this.button.textContent = label;
      }
    }
  }

  if (!customElements.get('hl-bundle')) customElements.define('hl-bundle', HlBundle);

  /* Abschnitte neu laden (Section Rendering API) */
  HL.renderSections = function (sections) {
    var names = sections.join(',');
    return fetch(window.Shopify.routes.root + '?sections=' + encodeURIComponent(names), {
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      return response.json();
    });
  };
})();
